import { useState } from "react"
import Button from '@material-ui/core/Button'
import axios from 'axios'

import { methodColorDict, methodNameDict } from '../../../../../app/thurstonianDicts'
import { DecisionRuleChooserCheckbox } from "../../../../ui/DecisionRuleChoosers";
import NumericInput from "../../../../ui/NumericInput";
import { useUpdateOutput } from "../../../../../hooks/store/useUpdateOutput";
import { useErrorHandler } from "../../../../../utils/apiUtils";
import { useSelector } from "react-redux";
import { nanoid } from "@reduxjs/toolkit";

const api = process.env.REACT_APP_API_URL

const FCPowerCalculation = ({ methods, setMethods, delta, setDelta, alpha, setAlpha, numTrials, setNumTrials }) => {

    const { checkAndPostError } = useErrorHandler()

    const { addOutput } = useUpdateOutput()

    const userId = useSelector(state => state.session.userId)
    const currentProjectId = useSelector(state => state.session.currentProjectId)

    // const [ methods, setMethods ] = useState(null)
    // const [ delta, setDelta ] = useState(null)
    // const [ alpha, setAlpha ] = useState(null)
    // const [ numTrials, setNumTrials ] = useState(null)
    const [ isValidating, setIsValidating ] = useState(false)
    
    const onSubmit = (event) => {
        
        event.preventDefault()

        setIsValidating(true)
      
        if(!(methods && delta && alpha && numTrials)) {
            return
        }
        
        setIsValidating(false)

        const methodsArray = Object.keys(Object.fromEntries(Object.entries(methods).filter(([key, value]) => value)))
        
        const apiData = {
            "function_group": "forced_choice_power",
            "function_name": "power_calculation",
            "methods": methodsArray.join('|'),
            "delta": Number(delta),
            "alpha": Number(alpha),
            "num_trials": Number(numTrials)
        }
        
        axios
            .post(api, apiData)
            .then((response) => {
                
                if(checkAndPostError(response)) {
                    return
                }

                let tempTable = [['Method:', 'Power:']]
                methodsArray.forEach((method) => {
                    tempTable.push([methodNameDict[method], response.data[method + '_power']])
                })

                const title = 'Power Calculation: ' + methodsArray.map(method => methodNameDict[method]).join(', ')
                const text = 'Delta < ' + delta.toFixed(2) + '   |   Alpha = ' + delta.toFixed(3) + '   |   # Trials = ' + numTrials.toString()
                
                let tempPlotData = [
                    {
                        x: methodsArray.map((method) => methodNameDict[method]),
                        y: methodsArray.map(
                            (method) => response.data[method + '_power']
                        ),
                        type: 'bar',
                        text: methodsArray
                            .map((method) => response.data[method + '_power'])
                            .map((val) => val.toFixed(2)),
                        textposition: 'auto',
                        width: 0.3,
                        customColors: methodsArray.map(
                            (method) => methodColorDict[method]
                        ),
                        hideTrace: true,
                        showlegend: false,
                        hovertemplate: ' %{x}: %{y:.2f}<extra></extra>',
                    },
                ]

                const newPlotId = nanoid()
                const newOutputId = nanoid()
                const plotObject = {
                        OwnerId: userId,
                        PlotId: newPlotId,
                        Title: title,
                        Data: tempPlotData,
                        OutputReferences: [newOutputId]
                    }
                
                const outputObject = {
                    OwnerId: userId,
                    OutputId: newOutputId,
                    Title: title, 
                    Stream: [
                        { Type: 'text', Content: text},
                        { Type: 'plot', Content: newPlotId }
                    ],
                    Plots: [newPlotId],
                    ReferencingProjectIds: currentProjectId,
                }
                
                addOutput(outputObject, plotObject)
                
            })
            .catch((error) => {
                console.log("error: ")
                console.log(error)
            })

    }

    return (
        <div id="FCPowerCalculationDialog">
            <form onSubmit={onSubmit}>
                    <DecisionRuleChooserCheckbox methodNameDict={methodNameDict} setValidatedValue={setMethods} isValidating={isValidating} defaultValue={methods} />
                    <NumericInput label="Delta" id="delta"
                        defaultValue={delta ? delta.toString() : ''}
                        setValidatedValue={setDelta}
                        minValue='0' maxValue='100000000' 
                        errorMessage='Delta must be greater than zero.'
                        isValidating={isValidating}
                    />
                    <NumericInput label="Alpha" id="alpha"
                        setValidatedValue={setAlpha}
                        defaultValue={alpha ? alpha.toString() : '0.05' }
                        minValue='0' maxValue='1' 
                        errorMessage='Alpha must be between 0 and 1.'
                        isValidating={isValidating}
                    />
                    <NumericInput label="# Trials" id="numTrials"
                        setValidatedValue={setNumTrials}
                        defaultValue={numTrials ? numTrials.toString() : ''}
                        minValue='0' maxValue='100000000' 
                        errorMessage='# Trials must be greater than 0.'
                        isValidating={isValidating}
                    />
                <br />
                <Button
                    style={{ padding: 3 }}
                    variant="contained"
                    color="primary"
                    type="submit"
                >
                    Run
                </Button>
            </form>
        </div>
    )
}

export default FCPowerCalculation

